import { render, staticRenderFns } from "./DetailRevenueReport.vue?vue&type=template&id=80337278"
import script from "./DetailRevenueReport.vue?vue&type=script&lang=js"
export * from "./DetailRevenueReport.vue?vue&type=script&lang=js"
import style0 from "./DetailRevenueReport.vue?vue&type=style&index=0&id=80337278&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports